module.exports = __webpack_public_path__ + "img/vereinigte-staaten.602993cf.png";